import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyEditChannel = lazy(() => import('./EditChannel'));

export const EditChannel: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyEditChannel {...props} />
	</Suspense>
);
